import angular from 'angular'

import { documentsService } from './services/documents.service'

const module = angular
  .module('deskfy.documents', [])
  .factory('DocumentsService', documentsService)

export const documentsModule = module
